import {
	Outlet,
	useLocation,
	useNavigate,
	useSearchParams,
} from 'react-router-dom';
import TabBar from '../../components/TabBar';
import { route } from '../../constants';
import addUser from '../../assets/icons/addUser.svg';
import searchIcon from '../../assets/icons/search.svg';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSearch } from '../../store/reducers/searchReducer';
import filter from '../../assets/images/filter.svg';
import ListFilter from '../../components/ListFilter';
import SidePopup from '../../components/SidePopup';
import { setAddOrUpdateRecruit } from '../../store/reducers/addOrUpdateRecruitReducer';
import { RootState } from '../../store/store';
import { setListQueryFilters } from '../../store/reducers/listFilterReducer';

const RecruitInformation = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const dispatch = useDispatch();
	const search = useSelector((store: RootState) => store.search);
	const filters = useSelector((store: RootState) => store.listFilter);
	const addOrUpdateRecruit = useSelector(
		(state: RootState) => state.addOrUpdateRecruit,
	);
	const userInfo = useSelector((state: RootState) => state.user);
	const [params] = useSearchParams();
	const [filterModel, setFilterModel] = useState(false);

	const [isRecruitListView, setIsRecruitListView] = useState(true);
	const tabs = [
		{
			title: 'My Recruits',
			path: `${process.env.PUBLIC_URL}/${route.recruitInformation}/${route.myRecruits}`,
		},
		{
			title: 'All Recruits',
			path: `${process.env.PUBLIC_URL}/${route.recruitInformation}/${route.allRecruits}`,
		},
	];

	useEffect(() => {
		if (location?.pathname.includes(route.allRecruits)) {
			dispatch(
				setListQueryFilters({
					...filters,
					isFilterRequired: false,
					isRecruitingManagersRequired: true,
				}),
			);
		} else if (location?.pathname.includes(route.myRecruits)) {
			dispatch(
				setListQueryFilters({
					...filters,
					isFilterRequired: false,
					isRecruitingManagersRequired: false,
				}),
			);
		} else if (location?.pathname === `/${route.recruitInformation}`) {
			if (userInfo.roles.adminAppEditOthersOwnedRecruit) {
				navigate(route.allRecruits);
			} else {
				navigate(route.myRecruits);
			}
		}
	}, [location.pathname, userInfo]);

	useEffect(() => {
		if (params.get('id')) {
			dispatch(
				setAddOrUpdateRecruit({
					isAddingRecruit: false,
					isUpdatingRecruit: true,
					isRecruitFieldsDisabled: true,
				}),
			);
			dispatch(
				setListQueryFilters({
					...filters,
					isFilterRequired: false,
				}),
			);
			return;
		}
		if (location.pathname.includes(route.addDetails)) {
			dispatch(
				setAddOrUpdateRecruit({
					isAddingRecruit: true,
					isUpdatingRecruit: false,
					isRecruitFieldsDisabled: false,
				}),
			);
			dispatch(
				setListQueryFilters({
					...filters,
					isFilterRequired: false,
				}),
			);
		} else {
			dispatch(
				setAddOrUpdateRecruit({
					isAddingRecruit: false,
					isUpdatingRecruit: false,
				}),
			);
		}
	}, [params, location]);

	const handleClick = () => {
		if (!userInfo.roles.adminAppAddRecruit) return;
		dispatch(
			setAddOrUpdateRecruit({
				isAddingRecruit: true,
				isUpdatingRecruit: false,
				isRecruitFieldsDisabled: false,
			}),
		);
		navigate(`/${route.recruitInformation}/${route.addDetails}`);
	};

	useEffect(() => {
		if (
			addOrUpdateRecruit?.isAddingRecruit ||
			addOrUpdateRecruit?.isUpdatingRecruit
		) {
			setIsRecruitListView(false);
		} else {
			setIsRecruitListView(true);
		}
	}, [addOrUpdateRecruit]);

	const handleSearch = (value: string) => {
		dispatch(setSearch(value));
	};

	const handleFilterClose = () => {
		setFilterModel(false);
	};

	const getFiltersCount = (): number => {
		return (
			(filters.roles?.split(',')?.filter((x) => x != '').length ?? 0) +
			(filters.stages?.length ?? 0) +
			(filters.all_external_managers?.length ?? 0) +
			(filters.recruiting_managers?.length ?? 0) +
			(filters.all_companies?.length ?? 0) +
			(filters.states?.length ?? 0)
		);
	};
	return (
		<div className="flex flex-col gap-y-5">
			{isRecruitListView ? (
				<div className="flex relative justify-between items-center rounded-lg py-2 bg-white">
					<TabBar links={tabs} />
					<div className="flex">
						<button
							className="flex gap-x-2 items-center border-2 p-2 my-2 rounded-lg border-rcrm-primary-border-blue"
							onClick={() => setFilterModel(true)}
						>
							<img src={filter} alt="" />
							<p>Filter </p>
							{getFiltersCount() > 0 && (
								<div className="w-5 h-5 rounded-full bg-rcrm-primary-bg flex justify-center items-center">
									{getFiltersCount()}
								</div>
							)}
						</button>
						<div className="flex items-center justify-between w-[300px] p-3 mx-3 my-2  bg-rcrm-primary-bg rounded-lg">
							<input
								className="outline-none flex-1 text-base text-rcrm-primary-blue bg-rcrm-primary-bg"
								type="text"
								placeholder="Search"
								onChange={(e) => handleSearch(e.target.value)}
								value={search ?? ''}
							/>
							<img className="w-4 h-4 " src={searchIcon} alt="" />
						</div>
						<button
							onClick={() => handleClick()}
							className="flex items-center gap-x-1 p-3 bg-rcrm-primary-blue  my-2 text-white rounded-lg mr-4"
						>
							<img src={addUser} alt="" />
							Add Recruit
						</button>
					</div>
				</div>
			) : null}
			{filterModel ? (
				<SidePopup
					isRight={true}
					isOpen={filterModel}
					onClose={handleFilterClose}
				>
					<ListFilter onCancel={handleFilterClose} />
				</SidePopup>
			) : null}
			<Outlet />
		</div>
	);
};
export default RecruitInformation;
